<app-message
    [successMessage]="false"
    [messageTitle]="'messages.request-failed.title' | translate"
    [message]="'messages.request-failed.description' | translate"
>
</app-message>
